import React, { useEffect, useState, useContext } from "react";
import { Card, Nav } from "react-bootstrap";
import { Link } from 'react-router-dom';
//import '../../styles/admin.css'
import { useLocation } from 'react-router-dom';
import { getPagesByLang } from "../admin/apiCalls";
import { store, StateProvider } from '../../Store';

const ObservatorySidebar = props => {
  const currentLocation = useLocation();
  
  const { state, dispatch } = useContext(store);
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;

  const [pagesList, setPagesList] = useState([]);
  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));

  useEffect(() => {
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  }, []);

  const styleTheme = {
    'navbar': `${configData && configData.theme}-navbar`,
    'active': `${configData && configData.theme}-active`
  }

  const refreshList = () => {
    getPagesByLang( 'es', (response) => {
      setPagesList(JSON.parse(response));
    });
  }  

  useEffect( refreshList, 'es');

  return (
    <>
      <Card >
      <Nav defaultActiveKey="/home" className={ "flex-column admin-sidebar " + styleTheme.navbar }>
        {/*<Link to={`/observatory`} className={currentLocation.pathname === `/observatory/` && 'active ' + styleTheme.active}>Observatorio de datos</Link>*/}
        {
        pagesList.map((item) => {
          return (<Link to={`/observatory/${item._id}`} className={currentLocation.pathname === `/observatory/${item._id}` && 'active ' + styleTheme.active}>{ item.title }</Link>)
        })
        }
      </Nav>
      </Card>
    </>
  );
  
}

export default ObservatorySidebar;